import { noop } from 'lodash';
import { FC } from 'react';
import { NewDestination, SocialDestination } from 'types/stream';
import getDestinationTitle from '../helpers/getDestinationTitle';
import { WarningMessage } from './Wrapper';

type ErrorDestinationsProps = {
  destinations: NewDestination[];
  destinationsWithError?: SocialDestination[];
};

const ErrorDestinations: FC<ErrorDestinationsProps> = ({ destinations, destinationsWithError }) => {
  return (
    <>
      {destinationsWithError?.map(d => {
        const currentDestination = destinations.find(
          destination => destination.network === d.network && destination.kind === d.kind
        );
        const handler = currentDestination?.onClick || noop;
        const handleClick = () => handler(currentDestination?.title);

        return (
          <WarningMessage key={d.id} variant="danger" position="left" isIcon={true}>
            <p>
              Wave.video live streaming studio has lost access to your {getDestinationTitle(currentDestination)}{' '}
              <b>({d.title})</b>. But, no worries, just {` `}
              <span onClick={handleClick}>click here to reconnect.</span>
            </p>
          </WarningMessage>
        );
      })}
    </>
  );
};

export default ErrorDestinations;
